import {call, fork, put, select, take} from 'redux-saga/effects';
import {ActionType} from "typesafe-actions";
import {Action} from "../index";
import {ResponseType} from "../../api/util";
import {Action as NotifyAction} from "../../NotificationSystem";

type Command = ActionType<typeof Action.Command.shareBoardWithAnyone>

function* handleShareBoardWithAnyone(command: Command) {
  const {response, error}: ResponseType = yield call(Action.Api.shareBoardWithAnyone, command.payload.boardId, command.payload.permissions);

  if(error) {
    yield put(NotifyAction.Command.error('Request Error', 'Failed to share board with anyone.'));
  }

  if(response) {
    yield put(NotifyAction.Command.info('Access Granted', 'Anyone now has access to the board.'));

    yield put(Action.Event.boardSharedWithAnyone(command.payload.boardId, command.payload.permissions));
  }
}

export function* shareBoardWithAnyoneFlow() {
  while (true) {
    const command: Command = yield take([
      Action.Type.SHARE_BOARD_WITH_ANYONE
    ]);

    yield fork(handleShareBoardWithAnyone, command);
  }
}
